import { RECEIVE_ENTRIES } from "../actions/types";
import entries from "samples/blog-entries";

export const fetch = () => (dispatch) => {
  dispatch({
    type: RECEIVE_ENTRIES,
    payload: entries,
  });
};
